import { useEffect } from 'react'
import { connectSocket } from './socket'
import { Dispatch } from '@reduxjs/toolkit'
import { addOrderFn } from '@/store/features/orders'
import { addNotificationOrder } from '@/store/features/notifications'
import Sound from '/sound.mp3'

export default function OrderSocketListener({
	token,
	dispacth,
}: {
	token: string
	dispacth: Dispatch
}) {
	useEffect(() => {
		const socket = connectSocket(token)

		socket.on('connected', (data) => {
			console.log('✅ Connected:', data)
		})

		socket.on('pong', (data) => {
			console.log('📶 Pong received:', data)
		})

		socket.on('stats', (data) => {
			console.log('📊 Stats:', data)
		})

		socket.on('newOrder', (data) => {
			const sound = new Audio(Sound)
			sound.play()
			dispacth(addOrderFn(data.order))
			dispacth(addNotificationOrder(data.order))
		})

		socket.on('paymentUpdate', (data) => {
			console.log('💳 Payment Update:', data)
		})

		socket.on('orderStatusChange', (data) => {
			console.log('🔄 Order Status Change:', data)
		})

		return () => {
			socket.disconnect()
		}
	}, [token])

	return null
}
